import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, L = { key: 1 }, V = { key: 2 }, f = { key: 3 }, k = { key: 4 }, y = { key: 5 }, A = {
  name: "ScalarIconGooglePlayLogo"
}, _ = /* @__PURE__ */ d({
  ...A,
  props: {
    label: {},
    weight: {}
  },
  setup(Z) {
    const r = Z, { bind: s, weight: a } = u(r);
    return (M, l) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      i(M.$slots, "default"),
      e(a) === "bold" ? (t(), o("g", g, l[0] || (l[0] = [
        n("path", { d: "M241.79,110.7,74,14.65a20.24,20.24,0,0,0-20.12.06A19.62,19.62,0,0,0,44,31.84V224.16a19.62,19.62,0,0,0,9.91,17.13,20.22,20.22,0,0,0,20.12.06l167.76-96a19.76,19.76,0,0,0,0-34.6ZM68,203V53l75,75ZM160,145l12.4,12.4-58,33.2ZM114.41,65.43l58,33.2L160,111ZM194,145l-17-17,17-17,29.72,17Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (t(), o("g", L, l[1] || (l[1] = [
        n("path", {
          d: "M160,128,58.32,230A7.7,7.7,0,0,1,56,224.45V31.55A7.7,7.7,0,0,1,58.32,26Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M239.82,114.18,72,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,48,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.76,15.76,0,0,0,0-27.64ZM64,212.67V43.33L148.69,128Zm96-73.36,18.92,18.92-88.5,50.66ZM90.4,47.1l88.53,50.67L160,116.69ZM193.31,150l-22-22,22-22,38.43,22Z" }, null, -1)
      ]))) : e(a) === "fill" ? (t(), o("g", V, l[2] || (l[2] = [
        n("path", { d: "M239.82,114.18,72,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,48,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.76,15.76,0,0,0,0-27.64ZM160,139.31l18.92,18.92-88.5,50.66ZM90.4,47.1l88.53,50.67L160,116.69ZM193.31,150l-22-22,22-22,38.43,22Z" }, null, -1)
      ]))) : e(a) === "light" ? (t(), o("g", f, l[3] || (l[3] = [
        n("path", { d: "M238.84,115.93,71,19.89a14,14,0,0,0-14.12,0A13.68,13.68,0,0,0,50,31.87V224.13a13.68,13.68,0,0,0,6.92,11.94,14,14,0,0,0,14.12,0l167.8-96a13.75,13.75,0,0,0,0-24.14ZM62,217.5V38.5L151.51,128Zm98-81,22.19,22.19L78.4,218.07ZM78.4,37.93l103.79,59.4L160,119.52ZM233,129.58l-.1.06L193,152.49,168.49,128,193,103.51l39.94,22.85.1.06a1.76,1.76,0,0,1,0,3.16Z" }, null, -1)
      ]))) : e(a) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        n("path", { d: "M239.82,114.19,72,18.16a16,16,0,0,0-16.12,0A15.68,15.68,0,0,0,48,31.87V224.13a15.68,15.68,0,0,0,7.92,13.67,16,16,0,0,0,16.12,0l167.78-96a15.75,15.75,0,0,0,0-27.62ZM64,212.67V43.33L148.69,128Zm96-73.36,18.92,18.92-88.5,50.66ZM90.4,47.1l88.53,50.67L160,116.69ZM193.31,150l-22-22,22-22,38.43,22Z" }, null, -1)
      ]))) : e(a) === "thin" ? (t(), o("g", y, l[5] || (l[5] = [
        n("path", { d: "M237.89,117.69,70.05,21.62a12,12,0,0,0-12.13,0A11.69,11.69,0,0,0,52,31.87V224.13a11.69,11.69,0,0,0,5.92,10.21,12,12,0,0,0,12.13,0l167.77-96a11.76,11.76,0,0,0,.07-20.66Zm-52.44-20.8L160,122.34,66.4,28.75ZM60,222.33V33.67L154.34,128Zm6.4,4.92L160,133.66l25.45,25.45Zm167.51-95.88L192.65,155l-27-27,27-27L234,124.66a3.77,3.77,0,0,1-.07,6.71Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
